import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const AuthService = {
  async register(payload) {
    return safeRequest(
      apiClient.post("/auth/register", payload).then((response) => response.data),
    );
  },

  async login(payload) {
    return safeRequest(
      apiClient.post("/auth/login", payload).then((response) => response.data),
    );
  },

  async patchPassword(payload) {
    return safeRequest(
      apiClient
        .patch("/auth/password", payload)
        .then((response) => response.data),
    );
  },
};
